export const unit = 8;

export const globalSmallGap = 2; // 16
export const globalMediumGap = 4; // 32
export const globalLargeGap = 6; // 48
export const globalXLGap = 8; // 64

export const spacing: number = unit;

// PADDINGS

// No padding
export const noPadding = { padding: 0 };
export const noPaddingTop = { paddingTop: 0 };
export const noPaddingBottom = { paddingBottom: 0 };
export const noPaddingLeft = { paddingLeft: 0 };
export const noPaddingRight = { paddingRight: 0 };
export const rootNoPadding = { root: noPadding };
export const rootNoPaddingTop = { root: noPaddingTop };
export const rootNoPaddingBottom = { root: noPaddingBottom };
export const rootNoPaddingLeft = { root: noPaddingLeft };
export const rootNoPaddingRight = { root: noPaddingRight };

// padding: 16px
export const globalInnerPadding = { padding: globalSmallGap * unit };
export const rootGlobalInnerPadding = { root: globalInnerPadding };

// padding: 0 16px
export const paddingSidesSm = {
  paddingTop: 0,
  paddingRight: globalSmallGap * unit,
  paddingLeft: globalSmallGap * unit,
  paddingBottom: 0,
};
export const rootPaddingSidesSm = { root: paddingSidesSm };

// padding: 16px 0
export const paddingTopBottomSm = {
  paddingTop: globalSmallGap * unit,
  paddingRight: 0,
  paddingBottom: globalSmallGap * unit,
  paddingLeft: 0,
};
export const rootPaddingTopBottomSm = { root: paddingTopBottomSm };

// MARGINS
export const centeredMargin = { margin: '0 auto' };
export const rootCenteredMargin = { root: centeredMargin };

export const noMargin = { margin: 0 };
export const rootNoMargin = { root: noMargin };

// margin: 16px
export const marginSm = { margin: globalSmallGap * unit };
export const rootMarginSm = { root: marginSm };

// margin: 16px 0
export const marginTopBottomSm = {
  paddingTop: globalSmallGap * unit,
  paddingRight: 0,
  paddingBottom: globalSmallGap * unit,
  paddingLeft: 0,
};

export const rootMarginTopBottomSm = { root: marginTopBottomSm };
